export default __webpack_public_path__ + "static/media/emptyBookmark.faf8b22b.svg";